export const numberFormat = (value, maximumFractionDigits = 2, minimumFractionDigits = 0) =>
    new Intl.NumberFormat('en-EN', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits,
        maximumFractionDigits
    }).format(value);

export const btcFormat = value =>
    new Intl.NumberFormat('en-EN', {
        currency: 'USD',
        maximumFractionDigits: 8
    }).format(value);

export const satoshiFormatter = value =>
    new Intl.NumberFormat('en-US', {
        currency: 'USD',
        maximumFractionDigits: 0
    }).format(value);
